import { Candidate } from "../Classes/Candidate";
import { NewCandidate } from "../Classes/NewCandidate";
import { plainToInstance } from "class-transformer";
import axios from "axios";
const url = "/api/candidate";

export const axiosCandidateConnected = async (
  id: string
): Promise<Candidate | null> => {
  try {
    const response = await axios.get(`${url}/${id}`);
    if (response.data == null) return null;
    const candidate = plainToInstance(Candidate, [response.data], {
      excludeExtraneousValues: true,
    })[0];
    return candidate;
  } catch (error) {
    console.log("Error retrieving candidate data: ", error);
    throw error;
  }
};

export const axiosCreateNewCandidate = async (
  newCandidate: NewCandidate
): Promise<any> => {
  try {
    const response = await axios.post(url, newCandidate);
    return response.data;
  } catch (error) {
    console.error("Error creating new candidate:", error);
    throw error;
  }
};
